import { Box, Chip, Stack, Typography } from "@mui/material";

import { reportTxt } from "../../../../../../../assets/texts/CloudAnalytics";
import { parseFormula } from "../utils";

type FormulaChipProps = {
  label: string;
};

type FormulaProps = { formula: string; tokens: string[] };

const FormulaChip = ({ label }: FormulaChipProps) => {
  // Remove parentheses from the label if they wrap the entire expression
  let displayLabel = label.startsWith("(") && label.endsWith(")") ? label.slice(1, -1) : label;

  // Add spaces around operators for better readability
  displayLabel = displayLabel
    .replace(/([+\-*/])/g, " $1 ") // Add spaces around operators
    .replace(/\s+/g, " ") // Normalize multiple spaces to single space
    .trim();

  return (
    <Chip
      label={
        <Typography variant="body2" sx={{ fontWeight: 500 }}>
          {displayLabel}
        </Typography>
      }
      sx={{ color: "palette.text.secondary" }}
    />
  );
};

const Formula = ({ formula, tokens }: FormulaProps) => {
  const formulaParts = parseFormula(formula, tokens);
  return (
    <Stack gap={1}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
        <Typography variant="body2" sx={{ fontWeight: 500 }}>
          {reportTxt.QUICK_VIEW_METRIC_FORMULA}
        </Typography>
      </Box>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        {formulaParts.map((part) => {
          if (part.type === "chip") {
            return <FormulaChip key={part.key} label={part.value} />;
          } else {
            return (
              <Typography key={part.key} component="span" variant="body2" sx={{ fontWeight: 500, whiteSpace: "pre" }}>
                {part.value}
              </Typography>
            );
          }
        })}
      </Box>
    </Stack>
  );
};

export default Formula;
